import { useEffect, useState } from "react";

const useAuthLayout = props => {
    const [isSignInOpen, setIsSignInOpen] = useState(false);
    const [isSignUpOpen, setIsSignUpOpen] = useState(false);
    const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
    const [showPhoneSignUp, setShowPhoneSignUp] = useState(false);
    const [verificationPhoneNumber, setVerificationPhoneNumber] = useState('');
    const [otpCode, setOtpCode] = useState('');
    const [purpose, setPurpose] = useState('');
    const [signUpMessage, setSignUpMessage] = useState({});
    const [showPhoneVerificationOpen, setShowPhoneVerificationOpen] = useState(false);
    const [phoneUp, setPhoneUp] = useState(false);
    const [phoneUpdate, setPhoneUpdate] = useState(false);
    const [directSubmit, setDirectSubmit] = useState(false);
    useEffect(() => {
        if (undefined !== props.isOpen && props?.isOpen) {
            setShowPhoneSignUp(true);
            setPhoneUp(false);
            if(props.phoneNumberUpdate){
                setPhoneUpdate(true);
            }
        }
    }, [props?.isOpen]);

    const handleSignInOpen = () => {
        setIsSignInOpen(true);
        setIsSignUpOpen(false);
        setIsForgotPasswordOpen(false);
    };

    const handleSignUpOpen = (message) => {
        if(undefined !== message && null !== message && "" !== message){
            setSignUpMessage(message);
            setTimeout(() => {
                setSignUpMessage({});
            }, 5000);
        }
        setShowPhoneSignUp(true);
        setPhoneUp(true);
    };

    const handleSignUpOpenFromPhoneVerification = (phoneNumber,isSignUpOpen) => {
        // setShowPhoneSignUp(true);
        setIsSignInOpen(false);
        setIsForgotPasswordOpen(false);
        setShowPhoneVerificationOpen(false);
        setShowPhoneSignUp(false);
        setIsSignUpOpen(true);
        setVerificationPhoneNumber(phoneNumber);
        setDirectSubmit(isSignUpOpen);
    };

    const LoginViaEmail = () => {
        setIsSignInOpen(true);
        setIsSignUpOpen(false);
        setIsForgotPasswordOpen(false);
        setShowPhoneSignUp(false);
        setShowPhoneVerificationOpen(false);
    };

    const handlePhoneVerificationOpen = (phoneNumber,otpCode,purpose,phoneUpdate,directSubmit) => {
        setDirectSubmit(directSubmit);
        setIsSignInOpen(false);
        // setIsSignUpOpen(false);
        setIsForgotPasswordOpen(false);
        setShowPhoneSignUp(false);
        setShowPhoneVerificationOpen(true);
        setVerificationPhoneNumber(phoneNumber);
        setOtpCode(otpCode);
        setPurpose(purpose);
        setPhoneUpdate(phoneUpdate);
    };

    const handleForgotPasswordOpen = () => {
        setIsSignInOpen(false);
        setIsSignUpOpen(false);
        setShowPhoneSignUp(false);
        setShowPhoneVerificationOpen(false);
        setIsForgotPasswordOpen(true);
    };

    const handleBackButton = (prevScreen, isLogin) => {
        const screens = {
            signIn: { phoneSignUp: isLogin ? false : true, signUp: false, forgotPassword: false },
            signUp: { phoneSignUp: isLogin ? false : true, signIn: false, forgotPassword: false },
            forgotPassword: { signIn: true, signUp: false },
            phoneSignUp: { phoneSignUp: false, signIn: isSignInOpen ? true : false, signUp: false },
            phoneVerification: { phoneSignUp: isLogin ? false : isSignUpOpen ? false : true, signIn: false, signUp: isSignUpOpen ? true : false }
        };
        const { signIn, signUp, forgotPassword, phoneSignUp, phoneVerification } = screens[prevScreen] || {};
        setPhoneUp(false);
        setIsSignInOpen(signIn ?? false);
        setIsSignUpOpen(signUp ?? false);
        setIsForgotPasswordOpen(forgotPassword ?? false);
        setShowPhoneSignUp(phoneSignUp ?? false);
        setShowPhoneVerificationOpen(phoneVerification ?? false);
        props.onClose(isLogin);
    };

    const handleForgotPasswordClose = () => {
        setIsForgotPasswordOpen(false);
        setIsSignInOpen(false);
        setIsSignUpOpen(false);
    };
    return {
        isSignInOpen,
        isSignUpOpen,
        isForgotPasswordOpen,
        showPhoneSignUp,
        showPhoneVerificationOpen,
        verificationPhoneNumber,
        otpCode,
        purpose,
        signUpMessage,
        phoneUp,
        phoneUpdate,
        directSubmit,
        handleSignUpOpen,
        handleForgotPasswordOpen,
        handleBackButton,
        handleSignInOpen,
        handleForgotPasswordClose,
        LoginViaEmail,
        handlePhoneVerificationOpen,
        handleSignUpOpenFromPhoneVerification
    };
};

export default useAuthLayout;
